import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[componentInsertion]'
})
export class ComponentInsertionDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
